import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Compass, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FBFBFA] flex flex-col items-center justify-center px-4 py-12">
      <img
        src="/logo_colorato.png"
        alt="Flusia"
        className="h-8 w-auto mb-12 opacity-80"
      />

      <div className="w-full max-w-md bg-white border border-gray-200 rounded-2xl p-10 text-center">
        <div className="mx-auto mb-6 h-16 w-16 rounded-full bg-gray-100 flex items-center justify-center">
          <Compass className="h-8 w-8 text-gray-500" strokeWidth={1.5} />
        </div>

        <h1 className="text-3xl font-semibold text-gray-900 mb-3 tracking-tight">
          Questa pagina non esiste
        </h1>

        <p className="text-base text-gray-500 leading-relaxed mb-8">
          L'URL che hai aperto non corrisponde a nessuna sezione del CRM. Forse il
          link è cambiato o la pagina è stata rimossa.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="default"
            onClick={() => navigate('/dashboard')}
            className="gap-2"
          >
            <Home className="h-4 w-4" />
            Torna alla dashboard
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="h-4 w-4" />
            Indietro
          </Button>
        </div>
      </div>
    </div>
  );
}
